module.exports = {"app.menu.home":"Home","app.menu.statistics":"Statistics","app.menu.scan_qr":"Scan QR","app.menu.login":"Login","app.menu.profile":"Profile","app.menu.logout":"Logout","app.menu.manage":"Manage","app.menu.companies":"Deparments","app.menu.users":"Users","home.machine_list":"Machine List"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 1076
// module chunks = 0